'use client';

import { usePathname } from 'next/navigation';
import { useAuth } from '@/platform/auth/useAuth';
import { TermsAcceptModal } from '@/platform/legal/TermsAcceptModal';
import { shouldShowTermsAcceptModal } from '@/platform/legal/termsGateModal';

export function TermsGate({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, needsTermsAcceptance, isLoading, sessionReady } = useAuth();
  const pathname = usePathname();

  const showModal =
    !isLoading &&
    sessionReady &&
    isAuthenticated &&
    needsTermsAcceptance &&
    shouldShowTermsAcceptModal(pathname);

  return (
    <>
      {children}
      {showModal ? <TermsAcceptModal /> : null}
    </>
  );
}
